import logoImage from 'assets/img/icons/logo.png';
import React, { Component } from "react";
import { t } from "i18next";
import { userActions } from 'redux/_actions';
import { connect } from 'react-redux';
//import { MdMenu, MdClose } from 'react-icons/md';
import { TbTruckDelivery } from 'react-icons/tb';
import { Button } from 'reactstrap';

class LandingNav extends Component {
    constructor(props) {
        super(props)
        this.state = {
            headerTransparent: window.pageYOffset < 60,
            windowWidth: window.innerWidth,
            menuOpen: false,
            showAuth: false,
        }
        this.updateDimensions = this.updateDimensions.bind(this);
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
        window.removeEventListener('scroll', this.handleScroll);
    }

    updateDimensions() {
        this.setState({windowWidth: window.innerWidth});
    }

    handleScroll(event) {
        let scrollTop = window.pageYOffset;
    
        this.setState({
            headerTransparent: scrollTop < 60
        });
    }

    render() {
        const {location} = this.props;
        
        const {windowWidth} = this.state;
        const homeLink = "/";
        // const individualLink = homeLink + '/individual';
        // const retailerLink = homeLink + '/retailer';
        // const helperLink = homeLink + '/helper';

        const barClasses = "landing-nav-container container";
        
        const icon = logoImage;
        
        return (
            <div className='landing-nav-wrapper'>
                <div className={barClasses}>
                    <a className='landing-nav-main' href={homeLink}>
                        <img src={icon} className="landing-nav-icon" alt='logo'/>
                    </a>
                    {/* <ul class='landing-nav-links'>
                        
                        <li class='landing-nav-li'>
                            <a 
                            href={individualLink} 
                            className={location === 'individual' ? "org-a-active" : "org-a"}>
                                {t('individuals')}
                            </a>
                        </li>
                        <li class='landing-nav-li'>
                            <a 
                            href={retailerLink} 
                            className={location === 'retailer' ? "org-a-active" : "org-a"}>
                                {t('retailers')}
                            </a>
                        </li>
                        <li class='landing-nav-li'>
                            <div  
                            className={location === 'helper' ? "org-a-active" : "org-a"} onClick={e=>{
                                if (!user) {
                                    this.setState({show: true});
                                } else {
                                    window.location = "/helper";
                                }
                            }}>
                                {t('become_a_helper')}
                            </div>
                        </li>
                    </ul> */}
                    <div className='wrap-content-fill-child' />
                    {location !== 'book' && (
                    <div className='landing-nav-action'>
                        <Button className="btn-landing-action" onClick={e=>{
                            /*if (!user) {
                                this.setState({showAuth: true});
                            } else {
                                window.location = "/book";
                            }*/
                            window.location = "/book";
                        }}>{windowWidth < 768 ? <TbTruckDelivery/> : t('book_delivery')}</Button>
                    </div>
                    )}
                </div>
            </div>
        );
    }
}

function mapState(state) {
    const { isAdmin, loggingIn, user, redirectTo } = state.authentication;
    return { isAdmin, loggingIn, user, redirectTo };
}

const actionCreators = {
    login: userActions.login,
    logout: userActions.logout,
    setAuthRedirect: userActions.setAuthRedirect,
};

const connectedLandingNav = connect(mapState, actionCreators)(LandingNav);
export { connectedLandingNav as LandingNav };
